// Builds a mailto: URL for the support inbox with a friendly subject and, when
// we know it, the instance reference so support can identify the tenant fast.
// mailto values must be percent-encoded per RFC 6068 (spaces as %20, not the
// form-style "+"), so we hand-encode rather than lean on URLSearchParams, which
// emits "+" that some mail clients render literally in the subject/body.
export const buildSupportMailto = (email: string, tenantId?: string | null): string => {
  const subject = "ZeroToClaw support request";
  const bodyLines = ["Hi ZeroToClaw team,", ""];
  if (tenantId !== null && tenantId !== undefined && tenantId.length > 0) {
    bodyLines.push("", `Instance reference: ${tenantId}`);
  }
  const query = `subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyLines.join("\n"))}`;
  return `mailto:${email}?${query}`;
};
